@if (!isDialogVisible) {
<div class="main">
    @if (codes) {
    <p-table [value]="codes" [tableStyle]="{ 'min-width': '50rem' }" [paginator]="true" [rows]="7" #table>
        <ng-template pTemplate="caption">
            <div class="header">
                <div class="title">
                    <span>All codes</span>
                    <span>·</span>
                    <span>{{codes.length || '0'}}</span>
                </div>
                <p-button icon="pi pi-plus" label="Create new" styleClass="rounded sm"
                    (onClick)="openNewCodeDialog()"></p-button>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th>Organization</th>
                <th>Expires on</th>
                <th>Access code</th>
                <th>Status</th>
                <th>Created on</th>
                <th style="width: 5rem;"></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-code>
            <tr>
                <td>{{ code.organization }}</td>
                <td>{{ code.expiresOn | date}}</td>
                <td>
                    <div class="chip">
                        {{ code.code }}
                        <img src="assets/icons/copy.svg" alt="" (click)="copy(code.code)" style="cursor: pointer;">
                    </div>
                </td>
                <td>
                    <div class="chip ratio">
                        {{ code.isUsed ? 'Used' : 'Not used' }}
                    </div>
                </td>
                <td>{{ code.createdAt | date}}</td>
                <td style="width: 5rem;">
                    <p-menu #menu [model]="items" [popup]="true" appendTo="body" />
                    <p-button (onClick)="menu.toggle($event);selectedCode=code;$event.stopPropagation()"
                        icon="pi pi-ellipsis-v" styleClass="p-button-secondary"></p-button>
                </td>
            </tr>
        </ng-template>
    </p-table>
    }@else if(!isLoading) {
    <div class="header">
        <div class="title">
            <span>All codes</span>
            <span>·</span>
            <span>0</span>
        </div>
        <p-button icon="pi pi-plus" label="Create new" styleClass="rounded sm"
            (onClick)="openNewCodeDialog()"></p-button>
    </div>
    <h3>No access codes available</h3>
    }
</div>
}
@if (isDialogVisible) {
<app-code-dialog [isVisible]="isDialogVisible" [isEdit]="isEdit" [code]="selectedCode"
    (onClose)="closeDialog($event)"></app-code-dialog>
}
<p-toast />
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>